export interface Bonus {
  number: string
  title: string
  tagline: string
  image: string
  alt: string
}

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Session Builder',
    tagline:
      'Scegli la seduta corretta rispondendo a 4 domande: obiettivo, numero di giocatori, livello e tempo disponibile.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/fc94ccf2-c6a8-4722-a212-f17762e8a0ef.jpg',
    alt: 'Copertina del Bonus 1: Session Builder, con un allenatore e la mappa della seduta.',
  },
  {
    number: '2',
    title: 'Correzioni Express',
    tagline: '50 errori tecnici comuni e una consegna semplice per correggerli.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/2dc8325b-9677-461a-aa07-9691073f6b93.jpg',
    alt: 'Copertina del Bonus 2: Correzioni express, con una giocatrice in bagher.',
  },
  {
    number: '3',
    title: 'Adattamento Gruppi Misti',
    tagline:
      'Lo stesso esercizio in 3 livelli: Base, Sviluppo e Performance. Meno giocatori fermi.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8bfa58c2-5134-496f-9287-d36526b0be49.jpg',
    alt: 'Copertina del Bonus 3: Adattamento gruppi misti, con il campo diviso in tre mini-campi.',
  },
  {
    number: '4',
    title: 'Riscaldamenti Specifici',
    tagline:
      'Protocolli pronti per ogni fondamentale, in versione rapida e completa.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c3fa0238-04d0-4c44-be4f-bf8ed9b8c163.jpg',
    alt: 'Copertina del Bonus 4: Riscaldamenti specifici, con giocatori in riscaldamento in palestra.',
  },
  {
    number: '5',
    title: 'Coaching Cues Library',
    tagline:
      '60+ consegne tecniche brevi, organizzate per fondamentale e problema osservato.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/32bc00c4-c278-41fe-8135-9c74edb4fe63.jpg',
    alt: 'Copertina del Bonus 5: Coaching cues library, con un allenatore che parla a una giocatrice.',
  },
]

/** Riepilogo breve usato nella tabella del valore. */
export const bonusValueRows: { label: string; value: string }[] = [
  { label: 'Bonus 1 — Session Builder', value: '€19' },
  { label: 'Bonus 2 — Correzioni Express', value: '€17' },
  { label: 'Bonus 3 — Adattamento Gruppi Misti', value: '€15' },
  { label: 'Bonus 4 — Riscaldamenti Specifici', value: '€14' },
  { label: 'Bonus 5 — Coaching Cues Library', value: '€12' },
]
